// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"7dc3cc29","491":"e568303e","671":"3bcf353f","674":"80b8709d","767":"7ec59835"}[chunkId] + ".chunk.js";
};